(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('UsageStatisticsCtrl', UsageStatisticsController);

  UsageStatisticsController.$inject = [
    '$scope',
    'UsagesService',
    'MessagesService',
    'OperacoesService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function UsageStatisticsController($scope, UsagesService, MessagesService, OperacoesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.usages = [];
    vm.loading = false;
    vm.user = null;
    vm.users = [];
    vm.onChangeUser = onChangeUser;

    //////////////////////////////////////////
    // Function declarations
    function initialize() {
      vm.loading = true;

      OperacoesService
        .usuarios()
        .then((result) => vm.users = result)
        .then(load);
    }

    function load() {
      vm.loading = true;

      return UsagesService.all({ usuario: vm.user }).then((data) => {
        vm.usages = data.data;
        vm.loading = false;
      });
    }

    function onChangeUser() {
      load();
    }

    //////////////////////////////////////////
    // Controller logic
    $scope.$root.initialize.then(initialize).catch((error) => {
      MessagesService.alert('Ocorreu um erro ao carregar as estatísticas de uso.');
      console.error(error);
      // Fecha modal, caso esteja em uma
      if ($scope.$close) {
        $scope.$close();
      }
    });
  }
}());
